import { Row, useTheme } from "@commonlibs";
import PointTable from "../PointTable/PointTable";
import { BaseCard, PointImage } from "./PointInfo.styles";
import { PointInfoProps } from "./PointInfo.types";

const PointInfo = ({ data, isLoading }: PointInfoProps) => {
    const { image = "", name = "" } = data || {};
    const { spacing } = useTheme();

    return (
        <BaseCard>
            <Row
                justifyContent="center"
                alignItems="center"
                gap={spacing[6]}
                breakpoint={{ width: "mobile", gap: "1rem", alignItems: "center" }}
            >
                <PointImage src={image} alt={`${name}-image`} />
                <PointTable data={data ? [data] : []} isLoading={isLoading} />
            </Row>
        </BaseCard>
    );
};

export default PointInfo;
